const StringifiedParameterFormatter = function(stringifiedValue, delimiter, objectPropertiesMap, singleValueFormatter){
    let formatted;
    if (typeof stringifiedValue !== 'string'){
        return formatted;
    }

    delimiter = delimiter || ';';

    let exploded = stringifiedValue.split(delimiter);
    if (objectPropertiesMap && objectPropertiesMap.hasOwnProperty('length')){
        formatted = {};
        for(let i=0; i<objectPropertiesMap.length; i++){
            let singleValue;
            if (typeof singleValueFormatter === 'function'){
                singleValue = singleValueFormatter(exploded[i]);
            }
            else{
                singleValue = exploded[i];
            }

            formatted[objectPropertiesMap[i]] = singleValue;
        }
    }
    else{
        formatted = [];
        for(let i=0; i<exploded.length; i++){
            let singleValue;
            if (typeof singleValueFormatter === 'function'){
                singleValue = singleValueFormatter(exploded[i]);
            }
            else{
                singleValue = exploded[i];
            }
            formatted.push(singleValue);
        }
    }

    return formatted;
};

export default StringifiedParameterFormatter;
